import { InjectionToken } from '@angular/core';


export const WORKSPACE_DATA: InjectionToken<string> = new InjectionToken<string>('WorkspaceTabData');
